import { Button, DatePicker, Form, Input, Row, Tooltip } from "antd";
import moment from "moment";
import * as React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { ReactComponent as CancelButtonIcon } from "../../img/buttons_icons/cancelButton_icon.svg";
import { ReactComponent as SubmitButtonIcon } from "../../img/buttons_icons/submitButton_icon.svg";
import { ReactComponent as AddVersionIcon } from "../../img/versions_icons/addVersion_icon.svg";
import { ReactComponent as EditIcon } from "../../img/versions_icons/editVersion_icon.svg";
import { MENU_ACCOUNT_ACCOUNTINFO_WRITE } from "../../lib/const/permissions";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { displayFormat, toDisplayFormat, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import "../../styles/row.less";
import { hasAccess } from "../RolesModule/hasAccess";
import { ReactComponent as DotsIcon } from "../../img/3dots.svg";
import HistoryAndPropertyModal from "../HistoryAndPropertyModal/HistoryAndPropertyModal";
import ToggleableVersionsTable from "../ToggleableVersionsTable/ToggleableVersionsTable";
import versionsTableUtils from "../../lib/utils/versionsTableUtils";

export default function AccountOrgNameVersionsTable(props) {
  const { changeOrganizationVersion, getAccountOrganizationVersions } = props;
  const {
    accountOrganization,
    accountOrganizationLoading,
    organizationsVersions,
    organizationsVersionsLoading,
  } = useSelector((state) => state.accounts);
  const currentDate = moment();
  const [childTableData, setChildTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [objectId, setObjectId] = useState(null);
  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  
  const [form] = Form.useForm();

  const isChangingForbidden = versionsTableUtils.getIsTableChanging(childTableData);

  const handleSetInitialValue = (field) => {
    setTimeout(() => {
      form.setFieldsValue(field);
    }, 0);
  };

  const showHistoryModal = (rec) => {
    setHistoryModalVisible(true);
    setObjectId(rec.id);
  };

  const columnsWidths = {
    ...versionsTableUtils.columnsWidths,
    fullName: 200,
    shortName: "",
  };

  const [columns, setColumns] = useState([
    {
      title: "Полное наименование",
      dataIndex: "fullName",
      key: "fullName",
      width: columnsWidths.fullName,
      hidden: false,
    },
    {
      title: "Краткое наименование",
      dataIndex: "shortName",
      key: "shortName",
      width: columnsWidths.shortName,
      hidden: false,
    },
    {
      title: "Период действия",
      dataIndex: "period",
      key: "period",
      width: columnsWidths.period,
      hidden: false,
      render(text, record) {
        if (record.fromDate && record.toDate) {
          return `${toDisplayFormat(record.fromDate)} - ${toDisplayFormat(record.toDate)}`;
        }
        return "";
      },
    },
    {
      dataIndex: "actions",
      key: "actions",
      width: columnsWidths.actions,
      hidden: false,
    },
    {
      dataIndex: "buttons",
      key: "buttons",
      width: columnsWidths.buttons,
      hidden: false,
      render(text, record) {
        return (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              showHistoryModal({ id: record.id });
            }}
            className="iconButton"
            type="text"
            htmlType="button"
            icon={<DotsIcon />}
          />
        );
      },
    },
  ]);

  const getChildColumns = () => [
    {
      title: "Полное наименование",
      dataIndex: "fullName",
      key: "fullName",
      width: columnsWidths.fullName,
      hidden: false,
      render(text, record) {
        if (record.isCreated || record.isEditing) {
          handleSetInitialValue({ fullName: text });
          return (
            <Form.Item
              name="fullName"
              className="form-item-required__hidden-error__mb0"
              rules={[{ required: true }]}
              // initialValue={text}
            >
              <Input />
            </Form.Item>
          );
        }
        return record.fullName;
      },
    },
    {
      title: "Краткое наименование",
      dataIndex: "shortName",
      key: "shortName",
      width: columnsWidths.shortName,
      hidden: false,
      render(text, record) {
        if (record.isCreated || record.isEditing) {
          handleSetInitialValue({ shortName: text });
          return (
            <Form.Item
              name="shortName"
              className="form-item-required__hidden-error__mb0"
              rules={[{ required: true }]}
              // initialValue={text}
            >
              <Input />
            </Form.Item>
          );
        }
        return record.shortName;
      },
    },
    {
      title: "Период действия",
      dataIndex: "period",
      key: "period",
      width: columnsWidths.period,
      hidden: false,
      render(text, record) {
        if (record.isCreated) {
          handleSetInitialValue({ fromDate: moment(record.fromDate).add(1, "day") });
          return (
            <>
              <Form.Item
                name="fromDate"
                className="form-item-required__hidden-error__mb0"
                rules={[{ required: true }]}
                style={{ display: "inline-block", marginRight: "5px" }}
              >
                <DatePicker
                  format={displayFormat}
                  allowClear={false}
                  disabledDate={(current) =>
                    current <= moment(record.fromDate) || current > moment(record.toDate)
                  }
                  // defaultPickerValue={moment(record.fromDate).add(1, "day")}
                />
              </Form.Item>
              <Form.Item
                style={{ display: "inline-block" }}
                className="form-item-required__hidden-error__mb0"
              >
                {` - ${toDisplayFormat(record.toDate)}`}
              </Form.Item>
            </>
          );
        }
        if (record.fromDate && record.toDate) {
          return `${toDisplayFormat(record.fromDate)} - ${toDisplayFormat(record.toDate)}`;
        }
        return "";
      },
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: columnsWidths.actions,
      hidden: false,
      render: (value, record) => {
        if (hasAccess(MENU_ACCOUNT_ACCOUNTINFO_WRITE)) {
          if (!record.isPastVersion && !record.isCreated && !record.isEditing) {
            return (
              <Row>
                <Tooltip title="Добавить версию">
                  <Button
                    className="button-icon"
                    icon={<AddVersionIcon />}
                    type="text"
                    htmlType="button"
                    disabled={isChangingForbidden}
                    onClick={(e) => {
                      e.stopPropagation();
                      setChildTableData((prevState) =>
                        [
                          {
                            ...record,
                            key: uuid(),
                            fromDate: moment(record.fromDate).add(1, "seconds"),
                            isCreated: true,
                            isCurrentVersion: false,
                            isPastVersion: false,
                            isLatestVersion: false,
                          },
                          ...prevState,
                        ].sort((a, b) => (moment(a.fromDate).isBefore(moment(b.fromDate)) ? 1 : -1))
                      );
                    }}
                  />
                </Tooltip>
                <Tooltip title="Редактировать версию">
                  <Button
                    className="button-icon"
                    icon={<EditIcon />}
                    type="text"
                    htmlType="button"
                    disabled={isChangingForbidden}
                    onClick={(e) => {
                      e.stopPropagation();
                      setChildTableData((prevState) =>
                        prevState.map((item) => {
                          if (item.key === record.key) return { ...item, isEditing: true };
                          return item;
                        })
                      );
                    }}
                  />
                </Tooltip>
              </Row>
            );
          }
          if (record.isCreated || record.isEditing) {
            return (
              <Row>
                <Tooltip title="Подтвердить">
                  <Button
                    className="button-icon"
                    icon={<SubmitButtonIcon />}
                    type="text"
                    htmlType="button"
                    onClick={(event) => {
                      event.stopPropagation();
                      form.submit();
                    }}
                  />
                </Tooltip>
                <Tooltip title="Отменить">
                  <Button
                    className="button-icon"
                    icon={<CancelButtonIcon />}
                    type="text"
                    htmlType="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (record.isEditing)
                        setChildTableData((prevState) =>
                          prevState.map((item) => {
                            if (item.isEditing) {
                              return { ...item, isEditing: false };
                            }
                            return item;
                          })
                        );
                      else
                        setChildTableData((prevState) => prevState.filter((obj) => !obj.isCreated));
                      form.resetFields();
                    }}
                  />
                </Tooltip>
              </Row>
            );
          }
        }
        return null;
      },
    },
    {
      title: "",
      dataIndex: "buttons",
      key: "buttons",
      width: columnsWidths.buttons,
      hidden: false,
    },
  ];

  const [childColumns, setChildColumns] = useState(getChildColumns());

  useEffect(() => {
    setChildColumns(getChildColumns());
  }, [isChangingForbidden]);

  useEffect(() => {
    if (checkIsLoaded(accountOrganizationLoading)) {
      setTableData([
        {
          key: accountOrganization.id,
          id: accountOrganization.id,
          fullName: accountOrganization.fullName,
          shortName: accountOrganization.shortName,
          fromDate: accountOrganization.fromDate,
          toDate: accountOrganization.toDate,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountOrganizationLoading]);

  useEffect(() => {
    if (checkIsLoaded(organizationsVersionsLoading)) {
      setChildTableData(
        organizationsVersions[0]
          .map((version, i) => ({
            key: `${version.id}${version.fromDate}`,
            id: version.id,
            fullName: version.fullName,
            shortName: version.shortName,
            fromDate: version.fromDate,
            toDate: version.toDate,
            properties: version.properties,
            isCurrentVersion:
              moment(currentDate).isSameOrAfter(version.fromDate) &&
              moment(currentDate).isBefore(version.toDate),
            isPastVersion: moment(version.toDate).isBefore(currentDate),
            isLatestVersion: organizationsVersions[0].length === i + 1,
            isClosing: false,
            isCreated: false,
            isEditing: false,
          }))
          .sort((a, b) => (moment(a.fromDate).isBefore(moment(b.fromDate)) ? 1 : -1))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationsVersionsLoading]);

  const handleCreateVersion = ({ fullName, shortName, fromDate }) => {
    const newVersion = childTableData.find((item) => item?.isCreated || item?.isEditing);
    const isForceUpdate = !!newVersion?.isEditing;
    const versionDate = isForceUpdate
      ? newVersion.fromDate
      : toHttpFormatStartOfDay(moment(fromDate));

    [
      "key",
      "isClosing",
      "isCreated",
      "isEditing",
      "isCurrentVersion",
      "isLatestVersion",
      "isPastVersion",
      "fromDate",
      "toDate",
    ].forEach((i) => delete newVersion[i]);

    changeOrganizationVersion(
      newVersion.id,
      versionDate,
      {
        ...newVersion,
        fullName,
        shortName,
      },
      () => getAccountOrganizationVersions(accountOrganization.id),
      isForceUpdate
    );
  };

  const handleHideModal = () => {
    setHistoryModalVisible(false);
    setObjectId(null);
  };

  return (
    <Form onFinish={handleCreateVersion} form={form}>
      <HistoryAndPropertyModal
        objectTypeSysname="organization"
        objectId={objectId}
        handleHideModal={handleHideModal}
        visibleModal={historyModalVisible}
        hasAccessToEdit={hasAccess(MENU_ACCOUNT_ACCOUNTINFO_WRITE)}
      />
      <ToggleableVersionsTable
        tableName="organization-name-table"
        columns={columns}
        setColumns={setColumns}
        childTableColumns={childColumns}
        setChildTableColumns={setChildColumns}
        tableData={tableData}
        childTableData={childTableData}
        isChildTableLoading={checkIsLoading(organizationsVersionsLoading)}
        tableClassName="organization-name-table"
        isPageable={false}
        isToggleableColumns={false}
        onOpenVersionsCallback={(record) => {
          getAccountOrganizationVersions(record.id);
        }}
      />
    </Form>
  );
}
